module.exports = __webpack_public_path__ + "static/media/amex.2dca617b.svg";